/* Glo Pals: restart the Yotpo reviews widget after a product swap (2026-11-04).
   Tapping another pal in the family picker swaps the page's sections in place
   (no reload). The swapped-in Yotpo block arrives as an empty
   .yotpo-widget-instance plus Yotpo's plain-text backup list, and Yotpo never
   re-scans on its own, so shoppers saw "Overall rating: ... AI Generated Review
   Summary" as raw text. When an EMPTY instance appears after page load, ask
   Yotpo to initialize it (initWidgets also removes the backup list). Filled
   instances are skipped, so Yotpo's own rendering never re-triggers this. */
(function () {
  if (window.__gpYotpoRefresh) return;
  window.__gpYotpoRefresh = true;
  var timer = null;
  function hasEmptyInstance() {
    var list = document.querySelectorAll('.yotpo-widget-instance[data-yotpo-product-id]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].firstElementChild) return true;
    }
    return false;
  }
  function refresh() {
    timer = null;
    var c = window.yotpoWidgetsContainer;
    if (!c || typeof c.initWidgets !== 'function' || !hasEmptyInstance()) return;
    try { c.initWidgets(); } catch (e) {}
  }
  function start() {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('.yotpo-widget-instance') || n.querySelector('.yotpo-widget-instance')) {
            if (!timer) timer = setTimeout(refresh, 150);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true }); // body: a swap may replace <main> itself
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
